export default __webpack_public_path__ + "static/media/steel-bridge.31fc0639.svg";